import React from "react";
import { Button } from "../../components/shared/Button/Button";
import { Icon } from "../../components/shared/Icon/Icon";
import { useLanguageContext } from "../../lib/context/LanguageContext/LanguageContext";
import "./Page404.scss";

export const Page404 = () => {
  const langCtx = useLanguageContext();
  const prefix = langCtx.getLangPrefix();

  return (
    <div className="Page404">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="Page404-wrapper">
              <Icon icon="alert-circle" className="Page404-alert" />
              <p>Faqja që keni kërkuar nuk egziston</p>
              <Button to={`${prefix}/`} color="blue">
                <Icon icon="home" className="mr-2" />
                Kthehu në faqen kryesore{" "}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
